import React, { useState, useEffect } from 'react';
import { MotifMenu, MotifMenuItem, MotifInput, MotifButton, MotifFormField, MotifIcon, MotifCheckbox, MotifLabel, MotifBadge, MotifTooltip } from "@ey-xd/motif-react";
import MotifSearch from '@ey-xd/motif-react/Search';
import { useNavigate } from "react-router-dom";
import { deleteIcon, lockIcon, checkPwdIcon, eyeCloseIcon, eyeIcon, passwordCursorIcon, IconoirCheckIcon, IconoirLockSlash,IconoirFilterList } from '../../common/MotifIcons';
import { apiQueryWithToken, apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import PendingFileTile from './PendingFileTile'
import ProgressCircle from './ProgressCircle';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import BreadcrumbNavigation from './BreadcrumbNavigation';
import { getAccount } from "../../common/services/commonService";
import SmallCircleLoader from './SmallCircleLoader';
import FilterIcon from '../../common/images/filter-list.svg';
import SortUpDark from '../../common/images/sort-up-dark.svg';
import SortDownDark from '../../common/images/sort-down-dark.svg';
import SortUpLight from '../../common/images/sort-up-light.svg';
import SortDownLight from '../../common/images/sort-down-light.svg';
import { getDateTimeFormat, getUploadedByFormat } from '../../common/utility/utility';

import './partnerFileUpload.scss';
import './PendingFiles.scss';
import logger from "../../common/utils/logger";
import { beginLongRunningTask } from "../../common/services/activityMonitor";

export const PendingFiles = ({ show, onClose, items, protectedFiles, handleRemoveFile, rowData, setTotalPendingCount, setInteraction, triggerEngagementUpdate, isPendingFilesLoading }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  const [activeTab, setActiveTab] = useState('clientEngagement'); // State for active tab
  const [passwords, setPasswords] = useState({});
  const [showValidatingLoader, setshowValidatingLoader] = useState({});
  const [isValidPassword, setIsValidPassword] = useState({});
  const [baseURL, setBaseURL] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [showError, setShowError] = useState({});
  const [isCorrectPassword, setIsCorrectPassword] = useState({}); // State to track password correctness
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentPath, setCurrentPath] = useState([]);
  const [uploadedFileLength, setUploadedFileLength] = useState(0);
  const [isUnlocking, setIsUnlocking] = React.useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState({});
  const [allProtectedFiles, setAllProtectedFiles] = useState([]);
  const [selectedControlIds, setSelectedControlIds] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [engLevelPendingPwd, setEngLevelPendingPwd] = useState("");
  const [engLevelValidating, SetEngLevelValidating] = useState(false);
  const [engLevelValidationCheck, SetengLevelValidationCheck] = useState(false);
  const [isEngLevelPasswordVisible, setIsEngLevelPasswordVisible] = useState(false);
  const [totalValidatedFiles, SetValidateFiles] = useState(0);
  const [engLevelValidatedControlIds, setEngLevelValidatedControlIds] = useState([]);

  const [validationCleanup, setValidationCleanup] = useState(null);
  // const [files, setFiles] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedUploader, setSelectedUploader] = useState(null);
  const [onClickAtoZ, setOnClickAtoZ] = useState(false);
  const [onClickZtoA, setOnClickZtoA] = useState(false);
  const [onClickNewest, setOnClickNewest] = useState(false);
  const [onClickOldest, setOnClickOldest] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  // State to track which files are being deleted
  const [deletingFiles, setDeletingFiles] = useState(new Set());
  // State to track which folders are being deleted
  const [deletingFolders, setDeletingFolders] = useState(new Set());

  const totalProtectedFile = allProtectedFiles.length;




  const eyOwnedFilesCount = (filteredData.length > 0 ? filteredData : allProtectedFiles)?.filter(allProtectedFiles => allProtectedFiles.isEyOwnFolder && !allProtectedFiles.isClientDataFolder).length;
  const clientEngagementFilesCount = (filteredData.length > 0 ? filteredData : allProtectedFiles)?.filter(allProtectedFiles => allProtectedFiles.isEyOwnFolder && allProtectedFiles.isClientDataFolder).length;

  const validateProtectedFiles = async () => {
    SetEngLevelValidating(true);


    const jsonPayload = {
      uploadGuid: null,
      engagementGuid: rowData?.engagementId_GUID,
      eng_Password: engLevelPendingPwd,
      engagementId: rowData?.engagementId,
      clientName: rowData?.clientName,
      UserEmailId: getAccount()?.username

    };
    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/upload/validate`,
        jsonPayload
      );
      if (response) {
        SetengLevelValidationCheck(false);
        const cleanup = await startValidationIteration();
        // setValidationCleanup(() => cleanup);
      }
      // SetEngLevelValidating(true);

    } catch (error) {
      SetEngLevelValidating(false);



    }
  };


  const GetValidationDetails = async () => {
    try {


      const payload = {
        "engagementGuid": rowData?.engagementId_GUID,
        "uploadGuid": null,
      };

      const { data } = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/getValidatedCount`,
        payload
      );

      return data;

    } catch (error) {
      return [];

    }
  };

  const startValidationIteration = async () => {
    let stopped = false;
    let timeoutID;

    const validationStatus = async () => {
      if (stopped) {
        return;
      }

      const data = await GetValidationDetails();

      if (data) {
        if (data[0]?.totalFileValidated > 0) {
          SetengLevelValidationCheck(true);
        }
      }
      const validControlIDs = data
        .filter(file => file.isPasswordValid && (file.validatedStatus === "Password Validated" || file.validatedStatus == "Completed"))
        .map(file => file.controlID);
      // Track engagement-level validated control IDs so UI can hide them immediately
      setEngLevelValidatedControlIds(validControlIDs);
      const validateFilesCount = data.filter(file => file.validatedStatus === "Password Validated").length;
      const stillValidating = data.filter(file => file.validatedStatus === "Password Validating").length;

      if (!stillValidating) {
        stopped = true;
        SetEngLevelValidating(false);
        SetengLevelValidationCheck(true);
      }
      const invalidControlIDs = data.filter(
        file =>
          !file.isPasswordValid &&
          (file.validatedStatus === "Password Validated" ||
            file.validatedStatus === "Completed")
      );

      const mappedItems = invalidControlIDs.map(item => ({
        fileName: item.filePath.split("/").pop(),
        filePath: item.filePath,
        controlId: item.controlID,
        isEyOwnFolder: true,
        isClientDataFolder: true
        // ensure controlid exists
      }));

      setAllProtectedFiles(prev => {
        // create a set of existing controlIds to check duplicates
        const existingIds = new Set(prev.map(file => Number(file.controlId)));

        // filter out items already in the list
        const newItems = mappedItems.filter(item => !existingIds.has(item.controlId));

        return [...prev.filter(file => !validControlIDs.includes(Number(file.controlId))), ...newItems];
      });

      timeoutID = setTimeout(validationStatus, 10000); // poll again after 10 seconds
    };

    validationStatus();

    // Return cleanup function
    return () => {
      stopped = true;
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
    };
  };

  const togglePasswordVisibility = (folderPath) => {
    setIsPasswordVisible(prev => ({
      ...prev,
      [folderPath]: !prev[folderPath]
    }));
  };

  const handleSelectAll = (event) => {
    const isSearching = (searchValue || "").trim().length > 0;
    const isUploaderFiltered = Array.isArray(selectedUploader) && selectedUploader.length > 0;

    // Get the relevant files based on search and uploader filter
    let relevantFiles = filteredData;
    if (isUploaderFiltered) {
      relevantFiles = relevantFiles.filter(file => selectedUploader.includes(file.uploadedBy));
    }

    if (event.target.checked) {
      if (isSearching || isUploaderFiltered) {
        // Select only the filtered (searched/uploader-filtered) files (merge with existing selection)
        const controlIds = (relevantFiles || []).map(f => f.controlId);
        setSelectedControlIds(prev => Array.from(new Set([...(prev || []), ...controlIds])));
      } else {
        // Default: select all files in allProtectedFiles
        const allControlIds = (allProtectedFiles || []).map(f => f.controlId);
        setSelectedControlIds(Array.from(new Set(allControlIds)));
      }
    } else {
      if (isSearching || isUploaderFiltered) {
        // Deselect only the currently filtered (searched/uploader-filtered) files, keep other selections
        const controlIdSet = new Set((relevantFiles || []).map(f => f.controlId));
        setSelectedControlIds(prev => (prev || []).filter(id => !controlIdSet.has(id)));
      } else {
        // Default: clear all selections
        setSelectedControlIds([]);
      }
    }
  };
  const handleSelectFile = (controlId) => {
    setSelectedControlIds(prevSelected => {
      if (prevSelected.includes(controlId)) {
        return prevSelected.filter(id => id !== controlId);
      } else {
        return [...prevSelected, controlId];
      }
    });
  };

  const handleDeleteSelectedFiles = (allFiles) => {
    const allControlIds = allFiles.map(file => file.controlId);
    setSelectedControlIds(allControlIds);

    setOpenDeleteDialog(true);
  };

  const confirmDeleteFiles = () => {
    // Add all selected files to deleting set
    setDeletingFiles(prev => new Set([...prev, ...selectedControlIds]));

    // Pass the array of control IDs directly
    const controlIdsString = selectedControlIds.join(',');
    handleRemoveFile({
      controlId: controlIdsString, // Pass the array of selected control IDs
      area: rowData?.area,
      noOfDeleteIcon: selectedControlIds.length, // Set the number of delete icons based on selected files
      noOfUploadedFiles: rowData?.noOfUploadedFiles,
      engagementTrackingStatus: rowData?.engagementTrackingStatus,
      engagementId: rowData?.engagementId,
      isPending: true
    });
    setSelectedControlIds([]); // Clear selected control IDs after deletion
    setOpenDeleteDialog(false); // Close the dialog after confirming
    setSelectedUploader([]);
  };
  const handleDeleteDialogClose = () => {
    // Remove files from deleting state if user cancels
    setDeletingFiles(prev => {
      const newSet = new Set(prev);
      selectedControlIds.forEach(id => newSet.delete(id));
      return newSet;
    });
    setSelectedControlIds([]);
    setOpenDeleteDialog(false);
  };

  const onPasswordChange = (fileName, newPassword) => {
    // const normalizedFilePath = fileName.startsWith("/") ? fileName.slice(1) : fileName;
    setPasswords(prevPasswords => ({
      ...prevPasswords,
      [fileName]: newPassword,
    }));
  };
  useEffect(() => {
    setActiveTab(rowData?.clientData ? 'clientEngagement' : 'eyOwned');
  }, [rowData?.clientData, rowData?.eyOwnedData]);

  const handleDialogClose = () => {
    setOpenDialog(false);
  };


  const handleClose = () => {
    // Stop validation polling when closing
    if (validationCleanup) {
      validationCleanup();
      setValidationCleanup(null);
    }
    SetEngLevelValidating(false);
    onClose();
    setIsFilterOpen(false);
    setSelectedUploader(null);
    setOnClickAtoZ(false);
    setOnClickZtoA(false);
    setOnClickNewest(false);
    setOnClickOldest(false);
  };


  // useEffect(() => {
  //   setEngLevelPendingPwd('')
  //   const initialPasswords = {};
  //   protectedFiles.forEach(file => {
  //     initialPasswords[file.controlId] = '';
  //     // initialPasswords[file.filePath_file.controlId?file.filePath:file.fileName&file.controlId] = ''; // Set initial password to empty
  //   });
  //   setPasswords(initialPasswords);
  //   setIsUploading(false);
  //   const initialPasswordState = {};
  //   protectedFiles.forEach(file => {

  //     //initialPasswordState[file.filePath?file.filePath:file.fileName] = false; // Set to false for each file
  //     initialPasswordState[file.controlId] = false;
  //     setshowValidatingLoader[file.controlId] = false;
  //   });
  //   setIsCorrectPassword(initialPasswordState);
  //   setShowError(initialPasswordState);
  //   setTotalPendingCount(eyOwnedFilesCount + clientEngagementFilesCount);

  //   setCurrentPath([]);
  //   setIsUploadDisabled(true);
  //   setAllProtectedFiles(protectedFiles);
  //   setSelectedControlIds([]);
  // }, [protectedFiles]);
  useEffect(() => {
    setEngLevelPendingPwd("");
    setPasswords(protectedFiles.reduce((acc, f) => ({ ...acc, [f.controlId]: "" }), {}));
    setIsCorrectPassword(protectedFiles.reduce((acc, f) => ({ ...acc, [f.controlId]: false }), {}));
    setShowError(protectedFiles.reduce((acc, f) => ({ ...acc, [f.controlId]: false }), {}));
    setshowValidatingLoader(protectedFiles.reduce((acc, f) => ({ ...acc, [f.controlId]: false }), {}));
    setAllProtectedFiles(protectedFiles);
    setSelectedControlIds([]);
    setCurrentPath([]);
    setTotalPendingCount(eyOwnedFilesCount + clientEngagementFilesCount);
    SetEngLevelValidating(false);
    SetengLevelValidationCheck(false);
    setEngLevelValidatedControlIds([]);
    setSearchValue('');
  }, [protectedFiles]);

  // Clear deletion states when files are removed successfully
  useEffect(() => {
    if (!isPendingFilesLoading) {
      setDeletingFiles(new Set());
      setDeletingFolders(new Set());
    }
  }, [isPendingFilesLoading]);

  React.useEffect(() => {
    if ((rowData?.area || "").toLowerCase() === "americas") {
      setBaseURL(process.env.REACT_APP_API_URL_US)
    } else if ((rowData?.area || "").toLowerCase() === "emeia") {
      setBaseURL(process.env.REACT_APP_API_URL_EU)
    } else if ((rowData?.area || "").toLowerCase() === "apac") {
      setBaseURL(process.env.REACT_APP_API_URL_AU)
    }

  }, [rowData?.area])

  // Cleanup validation polling when component closes
  useEffect(() => {
    if (!show && validationCleanup) {
      validationCleanup();
      setValidationCleanup(null);
      SetEngLevelValidating(false);
    }
  }, [show, validationCleanup]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (validationCleanup) {
        validationCleanup();
      }
    };
  }, []);

  useEffect(() => {
    setFilteredData((allProtectedFiles || []).filter((item) => {
      const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
      const shouldShowFile = (activeTab === 'eyOwned' ? item.isEyOwnFolder && !item.isClientDataFolder : item.isEyOwnFolder && item.isClientDataFolder); // Adjusted property names
      const isValidated = !!isCorrectPassword[item?.controlId];
      const engValidatedSet = new Set((engLevelValidatedControlIds || []).map(id => Number(id)));
      const isEngLevelValidated = engValidatedSet.has(Number(item?.controlId));
      // Hide validated files from UI
      return matchesSearch && shouldShowFile && !isValidated && !isEngLevelValidated;
    }));
  }, [allProtectedFiles, searchValue, activeTab, isCorrectPassword, engLevelValidatedControlIds]);
  const onFilterTextBoxChanged = (value) => {
    setSearchValue(value);
  };
  const handleFolderUnlock = async (filePath) => {
    // setIsUnlocking(true);
    const normalizedFilePath = filePath.startsWith("/") ? filePath.slice(1) : filePath;
    const currentFolderName = normalizedFilePath.split("/").pop();
    const nestedProtectedFiles = allProtectedFiles.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      // const normalizedFile = f.filePath.startsWith("/") ? f.filePath.slice(1) : f.filePath;
      return normalizedFile.startsWith(normalizedFilePath + '/');
    });

    const folderPasswordValue = passwords[filePath];
    const updatedPasswords = nestedProtectedFiles.reduce((acc, file) => {
      const isCorrect = isCorrectPassword[file.controlId];

      // Only update if password is incorrect or not checked yet
      if (isCorrect === false || isCorrect === undefined) {
        // Set file-level password
        acc[file.controlId] = folderPasswordValue;

        // Add folder path password(s)
        const normalized = file.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
        const parts = normalized.split('/');
        for (let i = 0; i < parts.length - 1; i++) {
          const folderPath = '/' + parts.slice(0, i + 1).join('/');
          acc[folderPath] = folderPasswordValue;
        }
      }

      return acc;
    }, {});

    setPasswords((prevPasswords) => ({
      ...prevPasswords,
      ...updatedPasswords,
    }));



    await Promise.all(
      nestedProtectedFiles.map(file => handleUnlockFile(file, folderPasswordValue, false))
    );


    //navigate to next level
    // setIsUnlocking(false);
    navigateToFolder(currentFolderName);
  };
  const hasProtectedFiles = (folderPath, passwordStatus) => {
    const normalizedFilePath = folderPath.startsWith("/") ? folderPath.slice(1) : folderPath;
    const nestedProtectedFiles = filteredData.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      return normalizedFile.startsWith(normalizedFilePath + '/');
    });
    for (const file of nestedProtectedFiles) {
      const status = passwordStatus[file.controlId];
      if (!status) {
        return true; // file is still protected
      }
    }
    return false; // All files password are vaildated
  }
  const isFileValidationInProcess = (folderPath, passwordStatus) => {
    const normalizedFilePath = folderPath.startsWith("/") ? folderPath.slice(1) : folderPath;
    const nestedProtectedFiles = filteredData.filter(f => {
      const normalizedFile = f.filePath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      return normalizedFile.startsWith(normalizedFilePath + '/');
    });
    for (const file of nestedProtectedFiles) {
      const status = showValidatingLoader[file.controlId];
      if (status) {
        return true; // file validation is in process
      }
    }
    return false; // All files validation is completed
  }

  const handleUnlockFile = async (file, folderPasswordValue, isRootCall = true) => {
    const isZip = (file.filePath ? file.filePath : file.fileName).endsWith(".zip");
    const fileControlID = file.controlId;
    const password = folderPasswordValue ? folderPasswordValue : passwords[fileControlID];
    setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: true }));

    if (password === "") {
      setShowError(prev => ({ ...prev, [fileControlID]: true }));
      setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false })); // Set correctness to false
      setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
      return
    }
    if (isZip) {
      await handleUnlockZipFile(file, password, isRootCall);
      return;
    }

    const jsonPayload = {
      controlId: parseInt(file.controlId, 10), // Convert controlId to integer
      eng_Password: String(password), // Ensure password is sent as a string
    };

    try {
      const response = await validateFiles(jsonPayload);
      // Check for invalid password response
      if (response === "Invalid Password" || (response && response.message === "Invalid Password") || typeof response === 'undefined') {
        // setOpenDialog(true); // Show the dialog for invalid password
        setShowError(prev => ({ ...prev, [fileControlID]: true }));
        setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false })); // Set correctness to false
        setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
      } else {

        setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: true })); // Set correctness to true
        setShowError(prev => ({ ...prev, [fileControlID]: false }));
        setIsUploadDisabled(false);
        setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
        setAllProtectedFiles(prev => prev.filter(file => file.controlId !== fileControlID));
      }
    } catch (error) {
      logger.error("Error unlocking file:", error);
      setIsCorrectPassword(prev => ({ ...prev, [fileControlID]: false }));
      setshowValidatingLoader(prev => ({ ...prev, [fileControlID]: false }));
      // Optionally, show an error message to the user
      // setErrorMessage("An error occurred while unlocking the file."); // Example error message
    }
  };
  const handleUnlockZipFile = async (file, zipPassword, isRootCall) => {

    const zipfileControlID = file.controlId;
    const password = zipPassword ? zipPassword : passwords[zipfileControlID];
    setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: true }));
    const jsonZipPayload = {
      controlId: parseInt(zipfileControlID, 10), // Convert controlId to integer
      eng_Password: String(password), // Ensure password is sent as a string
      engagementId: rowData?.engagementId,
      clientName: rowData?.clientName,
      userEmailId: getAccount()?.username,
      isPasswordValidated: false
    };

    try {
      const extractedFiles = []

      const response = await validateZipFiles(jsonZipPayload);
      //   Check for invalid password response
      if (!response.isPasswordValid || typeof response === 'undefined') {
        // setOpenDialog(true); // Show the dialog for invalid password
        setShowError(prev => ({ ...prev, [zipfileControlID]: true }));
        setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: false })); // Set correctness to false
        setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));

      } else {
        triggerEngagementUpdate(rowData.engagementId);
        // new code for new process
        setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: true })); // Set correctness to true
        setShowError(prev => ({ ...prev, [zipfileControlID]: false }));
        setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));

        setIsUploadDisabled(false);
        const initialPasswordState = {};
        const initialshowErrorMessage = {};
        response.zipFileContents.filter(item => item.isPasswordProtected).map((item, key) => {
          const fileControlID = item.controlId;
          const convertedPath = item.filePath.replace(/\\/g, "/");
          extractedFiles.push({
            engagementId: file.engagementId,
            fileName: convertedPath.split("/").pop(),
            filePath: `${convertedPath}`,
            isFolder: file.isFolder,
            isZip: file.isZip,
            isEyOwnFolder: file.isEyOwnFolder,
            isClientDataFolder: file.isClientDataFolder,
            controlId: fileControlID,
            dateCreated: file.dateCreated,
            uploadedBy: file.uploadedBy,
            isPasswordProtected: item.isPasswordProtected
          });
          initialPasswordState[fileControlID] = !item.isPasswordProtected;
          initialshowErrorMessage[fileControlID] = item.isPasswordProtected
        })
        setAllProtectedFiles(prev => [...prev.filter(file => file.controlId !== zipfileControlID), ...extractedFiles]);

        const folderPasswordValue = passwords[zipfileControlID];
        const updatedPasswords = extractedFiles.reduce((acc, file) => {
          const fileControlID = file.controlId;
          // Set file-level password
          acc[fileControlID] = folderPasswordValue;
          const convertedPath = file.filePath.replace(/\\/g, "/");
          // Add folder path password(s)
          const normalized = convertedPath.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
          const parts = normalized.split('/');
          for (let i = 0; i < parts.length - 1; i++) {
            const folderPath = '/' + parts.slice(0, i + 1).join('/');
            acc[folderPath] = folderPasswordValue;
          }

          return acc;
        }, {});

        setPasswords((prevPasswords) => ({
          ...prevPasswords,
          ...updatedPasswords,
        }));
        setIsCorrectPassword(prev => ({ ...prev, ...initialPasswordState }));
        setShowError(prev => ({ ...prev, ...initialshowErrorMessage }));


        // setIsUploadDisabled(false);
        const filteredData = allProtectedFiles?.filter((item) => {
          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
          const shouldShowFile = (activeTab === 'eyOwned' ? item.isEyOwnFolder && !item.isClientDataFolder : item.isEyOwnFolder && item.isClientDataFolder); // Adjusted property names
          return matchesSearch && shouldShowFile;
        });
        fileStructure = buildFileStructure(filteredData);
        if (isRootCall && (response.zipFileContents ? response.zipFileContents.filter(item => item.isPasswordProtected).length > 0 : false)) {
          navigateToFolder(file.fileName);
        }


      }

    } catch (error) {
      logger.error("Error unlocking file:", error);
      setIsCorrectPassword(prev => ({ ...prev, [zipfileControlID]: false }));
      setshowValidatingLoader(prev => ({ ...prev, [zipfileControlID]: false }));

      // Optionally, show an error message to the user
      // setErrorMessage("An error occurred while unlocking the file."); // Example error message
    }
  };
  const validateFiles = async (jsonPayload) => {
    // setIsLoading(true);
    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/pending/update`,
        jsonPayload
      );
      return response.data;
    } catch (error) {
      // Handle the error     
      logger.error("File validation failed:", error);
    }
  };
  const validateZipFiles = async (jsonPayload) => {
    try {
      const response = await apiQueryToUploadDataRegional.post(
        `${baseURL}/api/partners/pending/zip/validate`,
        jsonPayload
      );

      return response.data;
    } catch (error) {
      // Handle the error
      logger.error("File validation failed:", error);
    }
  };
  const handleDeleteFile = (controlId) => {
    // Add file to deleting set immediately when delete is triggered
    setDeletingFiles(prev => new Set([...prev, controlId]));

    // Set the control ID to delete and open the confirmation dialog
    setSelectedControlIds([controlId]); // Set the selected control ID for deletion
    setOpenDeleteDialog(true); // Open the delete confirmation dialog
  };
  // `isUploading` is deliberately not used as the timeout signal: it is set true
  // below and never set back to false, and this component never unmounts, so it
  // would hold the longer window open for the rest of the session. The
  // registration is scoped to the actual request loop instead.
  const handleUploadFiles = async () => {
    const endLongRunningTask = beginLongRunningTask("pending-files-password-validation");
    try {
      await runUploadFiles();
    } finally {
      endLongRunningTask();
    }
  };

  const runUploadFiles = async () => {
    triggerEngagementUpdate(rowData.engagementId);
    // Reset progress to 0
    setUploadProgress(0);
    setIsUploading(true); // Start the upload process

    // Create an array to hold files with correct passwords
    const validFiles = [];

    // Iterate over the filtered data (pending files) to check for correct passwords
    const finalUploadList = filteredData.filter(item => item.isPasswordProtected === true || item.isPasswordProtected === undefined);

    for (const file of finalUploadList) {
      // Check if the password is correct using isCorrectPassword state
      if (isCorrectPassword[file.controlId]) {
        validFiles.push(file); // Add file to valid files list
      }
    }

    // Now proceed to upload only the valid files
    const totalFiles = validFiles.length;
    setUploadedFileLength(totalFiles);
    let uploadedFilesCount = 0;

    for (const file of validFiles) {
      const password = passwords[file.controlId];

      try {
        if (!file.fileName.endsWith(".zip")) {
          // Prepare the JSON payload
          const jsonPayload = {
            controlId: parseInt(file.controlId, 10), // Convert controlId to integer
            eng_Password: String(password), // Ensure password is sent as a string
          };

          // Call the update password API for each file
          const response = await apiQueryToUploadDataRegional.post(
            `${baseURL}/api/partners/pending/update`, jsonPayload
          );
        } else {
          const jsonZipPayload = {
            controlId: parseInt(file.controlId, 10), // Convert controlId to integer
            eng_Password: String(password), // Ensure password is sent as a string
            engagementId: rowData?.engagementId,
            clientName: rowData?.clientName,
            userEmailId: getAccount()?.username,
            isPasswordValidated: true
          };

          // Call the update password API for each file
          const response = await apiQueryToUploadDataRegional.post(
            `${baseURL}/api/partners/pending/zip/validate`, jsonZipPayload
          );
        }

        // Update the number of uploaded files and progress
        uploadedFilesCount++;
        setUploadProgress(Math.round((uploadedFilesCount / totalFiles) * 100)); // Round to nearest integer
      } catch (error) {
        logger.error(`Failed to update password for file: ${file.fileName}`, error);
      }
    }

    setCurrentPath([]);
    // Finish the upload process
    // setIsUploading(false);
  };
  // const updateFileStructureWithZipContents = (structure, zipFile, extractedFiles) => {
  //   const pathParts = zipFile.filePath.replace(/\\/g, "/").replace(/\/{2,}/g, "/").split("/");
  //   const zipFileName = pathParts.pop();
  //   const fileIdentifier = zipFileName + zipFile.controlId;

  //   let currentLevel = structure;

  //   pathParts.forEach(folder => {
  //     if (!currentLevel.subFolders[folder]) {
  //       currentLevel.subFolders[folder] = { path: "", files: {}, subFolders: {} };
  //     }
  //     currentLevel = currentLevel.subFolders[folder];
  //   });

  //   // Add zip file itself if not present
  //   if (!currentLevel.subFolders[zipFileName]) {
  //     currentLevel.subFolders[zipFileName] = { path: zipFile.filePath, files: {}, subFolders: {} };
  //   }

  //   // Go into the zip folder
  //   const zipFolderLevel = currentLevel.subFolders[zipFileName];

  //   // Add extracted files
  //   extractedFiles.forEach(file => {
  //     const normalizedPath = file.filePath.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
  //     const pathParts = normalizedPath.split("/");
  //     const fileName = pathParts.pop();
  //     const fileIdentifier = fileName + file.controlId;

  //     let folderLevel = zipFolderLevel;

  //     pathParts.forEach(folder => {
  //       if (!folderLevel.subFolders[folder]) {
  //         folderLevel.subFolders[folder] = { path: "", files: {}, subFolders: {} };
  //       }
  //       folderLevel = folderLevel.subFolders[folder];
  //     });

  //     folderLevel.files[fileIdentifier] = { ...file };
  //   });

  //   return structure;
  // };

  const buildFileStructure = (files) => {
    let structure = { path: "", files: {}, subFolders: {} };

    files.forEach(file => {
      if (!file.filePath) {
        const fileIdentifier = file.fileName + file.controlId;
        structure.files[fileIdentifier] = file;
        return;
      }
      const normalizedPath = file.filePath.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
      const pathParts = normalizedPath.split("/");
      const fileName = pathParts.pop(); // Extract file name
      const fileControlID = file.controlId;
      const fileIdentifier = fileName + fileControlID;

      let currentLevel = structure;
      let currentPath = "";

      pathParts.forEach(folder => {
        currentPath += "/" + folder;
        if (!currentLevel.subFolders[folder]) {
          currentLevel.subFolders[folder] = { path: currentPath, files: {}, subFolders: {} };
        }
        currentLevel = currentLevel.subFolders[folder];
      });

      currentLevel.files[fileIdentifier] = { ...file };
    });
    return structure;
  }
  // const sortedFilterData = filteredData.sort((a, b) => Number(a.controlId) - Number(b.controlId));
  let fileStructure = buildFileStructure(filteredData);
  const getCurrentFolderContents = () => {
    let currentLevel = fileStructure; // Start from root
    for (const part of currentPath) {
      if (!currentLevel.subFolders[part]) {
        return { subFolders: {}, files: {} }; // Return empty structure if path is invalid
      }
      currentLevel = currentLevel.subFolders[part]; // Navigate deeper
    }
    return currentLevel;
  };
  const navigateToFolder = (folderName) => {
    const newPath = [...currentPath, folderName];
    setCurrentPath(newPath);
  };

  const getAllFilesRecursively = (folder) => {
    let files = Object.values(folder.files || {});
    for (const sub of Object.values(folder.subFolders || {})) {
      files = files.concat(getAllFilesRecursively(sub));
    }
    return files;
  }
  const handleFolderCheckboxChange = (folderName, filesInFolder) => {
    const isChecked = filesInFolder.every(file => selectedControlIds.includes(file.controlId));
    if (isChecked) {
      const controlIdsToRemove = filesInFolder.map(file => file.controlId);
      setSelectedControlIds(prev => prev.filter(id => !controlIdsToRemove.includes(id))); // Remove control IDs
    } else {
      const controlIdsToAdd = filesInFolder.map(file => file.controlId);
      setSelectedControlIds(prev => [...new Set([...prev, ...controlIdsToAdd])]); // Add unique control IDs
    }
  };

  const goBack = (index) => {
    if (index === -1) {
      setCurrentPath([]);
    } else {
      setCurrentPath(currentPath.slice(0, index + 1));
    }
  };
  const countFilesRecursively = (folder) => {
    return Object.keys(folder.files || {}).length +
      Object.values(folder.subFolders || {}).reduce(
        (count, subFolder) => count + countFilesRecursively(subFolder), 0
      );
  };
  // const currentFolderContents = getCurrentFolderContents();
  // const filteredData = allProtectedFiles?.filter((item) => {
  //   const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
  //   return matchesSearch;
  // });
  // let fileStructure = buildFileStructure(filteredData);
  useEffect(() => {
    const folderContents = getCurrentFolderContents();
    setCurrentFolderContents(folderContents);
  }, [currentPath, searchValue, allProtectedFiles, filteredData]);
  const [currentFolderContents, setCurrentFolderContents] = useState(getCurrentFolderContents());

  const handleToggleSelectAllUploaders = () => {
    // Always get all uploaders from the full items list, not filteredData
    const allUploaders = Array.from(new Set((items || []).map(file => file.uploadedBy)));
    if (
      Array.isArray(selectedUploader) &&
      selectedUploader.length === allUploaders.length
    ) {
      // Deselect all
      setSelectedUploader([]);
      setFilteredData(
        (items || []).filter((item) => {
          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
          const shouldShowFile = activeTab === 'eyOwned' ? item.isEyOwnFolder && !item.isClientDataFolder : item.isEyOwnFolder && item.isClientDataFolder;
          return matchesSearch && shouldShowFile;
        })
      );
      setSelectedControlIds([]);
    } else {
      // Select all
      setSelectedUploader(allUploaders);
      setFilteredData(
        (items || []).filter((item) => {
          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
          const shouldShowFile = activeTab === 'eyOwned' ? item.isEyOwnFolder && !item.isClientDataFolder : item.isEyOwnFolder && item.isClientDataFolder;
          return matchesSearch && shouldShowFile && allUploaders.includes(item.uploadedBy);
        })
      );
    }
  };
  return (
    (<MotifMenu show={show} onClose={handleClose} className="motif-menu-container motif-menu-container-pending">

      <div className="motif-menu-view-files-container">
        <MotifMenuItem className="motif-menu-view-files" disabled>
          <strong>Pending Password</strong>
          <div className="engagement-id engagement-id-pending">
            {rowData?.engagementId} | {rowData?.engagementName}
          </div>
        </MotifMenuItem>
      </div>

      <div className="tab-buttons">
        {rowData?.clientData && (
          <MotifButton
            className={activeTab === 'clientEngagement' ? 'selected' : ''}
            variant={activeTab === 'clientEngagement' ? 'primary' : 'secondary'}
            onClick={() => { setActiveTab('clientEngagement'); setCurrentPath([]) }} // Use the correct string that matches the data property
          >
            Client Data & EY Owned Data<span className="no-of-files">{clientEngagementFilesCount}</span>
          </MotifButton>
        )}
        {!rowData?.clientData && (
          <MotifButton
            className={activeTab === 'eyOwned' ? 'selected' : ''}
            variant={activeTab === 'eyOwned' ? 'primary' : 'secondary'}
            onClick={() => { setActiveTab('eyOwned'); setCurrentPath([]) }} // Use the correct string that matches the data property
          >
            EY Owned Data<span className="no-of-files">{eyOwnedFilesCount}</span>
          </MotifButton>
        )}
      </div>


      {isLoading || isUnlocking || isPendingFilesLoading ? <MotifProgressLoader
        show
        variant="default"
      /> : (<div className="pending-files-display">
        {allProtectedFiles.length !== 0 &&
          <MotifFormField className='pending-files-display__form'>
            <MotifLabel className='pending-files-display__label' >Enter common engagement-<br /><span className='pending-files-display__label-two '>level password</span></MotifLabel>
            <MotifFormField
              className="pending-files-display__field"
            >
              <div className="input-with-icon">
                <MotifIcon
                  src={passwordCursorIcon}
                  className="input-icon"
                ></MotifIcon>
                <MotifInput
                  hideClearButton={true}
                  //  onClose={() => { }}
                  aria-label="Password"
                  placeholder="Password (required)"
                  value={engLevelPendingPwd}
                  onChange={(e) => { setEngLevelPendingPwd(e.target.value); }}
                  type={isEngLevelPasswordVisible ? 'text' : 'password'}
                />
              </div>
              {engLevelPendingPwd.length > 0 && (
                <button className="ft-eng-password-toggle" onClick={() => setIsEngLevelPasswordVisible(!isEngLevelPasswordVisible)}>
                  <MotifIcon src={isEngLevelPasswordVisible ? eyeCloseIcon : eyeIcon} />
                </button>
              )}
              {engLevelPendingPwd.length > 0 && <div className='icon-container'>
                {!(engLevelValidating) ? (<div className='check-close-icon' onClick={() => { validateProtectedFiles() }}>
                  <MotifIcon src={IconoirCheckIcon} alt='Clear Check Icon' /></div>) : null}
              </div>}

            </MotifFormField>
          </MotifFormField>
        }
        {/* <div className="image-container">
          <img src={require("../../common/images/Featured icon.png")} alt="Excel File Icon" className="center-image" />
        </div>
        <span className="bold-small">We need a password for the below files</span>
        <br />
        <span className="normal-small">Enter the password now or click "Upload" to enter the password later.</span>
        <br /> */}

        <div className='motif-label grid-container-inner'>
          {engLevelValidating && <div style={{ marginLeft: '15px' }}> <SmallCircleLoader /> Validating Files </div>}
          {(!engLevelValidating && engLevelValidationCheck) && <div style={{ marginLeft: '20px' }}>Validation Completed</div>}

        </div>
        <div className="files-search-container">
          <MotifFormField>
            <MotifSearch
              aria-label='Search'
              onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
              placeholder='Search...'
              value={searchValue}
            />
          </MotifFormField>
        </div>

        {/* <div className="text-container-pending">
          <span className="ft-normal-small">Your password is encrypted and stored temporarily and will be deleted after processing the files.</span>
        </div> */}
        {isUploading ? (
          // Render the progress circle and messages when uploading
          <div className="progress-page">
            <div className="progress-container">
              <ProgressCircle percentage={uploadProgress} failedCount={0} />
              <div className="progress-message">
                {uploadProgress === 100 ? (
                  <>
                    <p><strong>{uploadedFileLength} {uploadedFileLength === 1 ? 'File is' : 'Files are'} Uploaded.</strong></p>
                    <p>You can close the window.</p>
                  </>
                ) : (
                  <>
                    <p><strong> We are uploading {uploadedFileLength} {uploadedFileLength === 1 ? 'File' : 'Files'}... </strong></p>
                    <p>Please do not close the window.</p>
                  </>
                )}
                <div className="upload-close-button-container">
                  <MotifButton variant="primary" onClick={handleClose}>
                    Close
                  </MotifButton>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Render the file list and buttons when not uploading
          <>
            <div className="file-list-container file-list-container-spacing">
              <div className="file-list-breadcrumb">
                {filteredData.length > 0 && (
                  <BreadcrumbNavigation currentPath={currentPath} goBack={goBack} isClientEngagement={activeTab === 'clientEngagement'} />
                )}
                 {filteredData.length > 0 && !isUploading && (<div className="pending-select-all-container pending-select-all-container-box" >

          <div className='global-actions'>
            <MotifButton
              style={{ gap: "6px", height: 27 }}
              variant="secondary"
              onClick={() => {
                if (selectedControlIds.length > 0) {
                  setOpenDeleteDialog(true); // Open the dialog only if there are selected control IDs
                }
              }}
              disabled={selectedControlIds.length === 0}
            >
              <MotifIcon
                src={deleteIcon}
                style={{ width: "17px", height: "17px", gap: "16px" }}
              />
              Delete all
            </MotifButton>
            <MotifButton
              style={{ gap: "6px", height: 27 }}
              variant="secondary"
              onClick={() => setIsFilterOpen(!isFilterOpen)}

            >
              <MotifIcon
                src={IconoirFilterList}
                style={{ width: "17px", height: "17px", gap: "16px" }}
              />
              Filter
            </MotifButton>
          </div>
          <div className='select-all-checkbox-box pending-grid-container-inner'>
             <div className="left-section left-section-pending">
            <MotifCheckbox
              id="select-all"
              onChange={handleSelectAll}
              checked={
                (() => {
                  const isSearching = (searchValue || "").trim().length > 0;
                  const isUploaderFiltered = Array.isArray(selectedUploader) && selectedUploader.length > 0;

                  if (isSearching || isUploaderFiltered) {
                    // Only check files in filteredData (search/uploader filter)
                    return (filteredData?.length ?? 0) > 0 && filteredData.every(f => selectedControlIds.includes(f.controlId));
                  }
                  // Default: check all files in allProtectedFiles
                  return (allProtectedFiles?.length ?? 0) > 0 && allProtectedFiles.every(f => selectedControlIds.includes(f.controlId));
                })()
              }
            />
            <span className="selectAll-text">Files Name</span></div>
                  <span className="selectAll-text" style={{width:'28%'}}>Password(Required) </span>
                        <span className="selectAll-text" style={{width:'12%'}}>Actions</span>
          </div>
          {/* <span
            className="delete-text"
            style={{
              marginLeft: 150,
              cursor: selectedControlIds.length === 0 ? 'not-allowed' : 'pointer',
              fontWeight: '500',
              opacity: selectedControlIds.length === 0 ? 0.5 : 1 // Optional: Change opacity to indicate disabled state
            }}
            onClick={() => {
              if (selectedControlIds.length > 0) {
                setOpenDeleteDialog(true); // Open the dialog only if there are selected control IDs
              }
            }}
          >
            Delete
          </span>
          <div style={{ borderLeft: '1px solid #C3C3CB', height: '20px' }} />
          <span onClick={() => setIsFilterOpen(!isFilterOpen)} style={{ cursor: 'pointer' }}><span style={{ fontWeight: '400', fontSize: '14px', lineHeight: '20px', color: '#656579' }}>Filter</span><img className='file-filter-icon' src={FilterIcon} style={{ height: 11, verticalAlign: 'middle' }} /></span> */}
      
        </div>
        )}
        {isFilterOpen && (
          <MotifMenu className="pending-file-filter-menu" show={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
            <div className='pending-file-filter-menu__title-one'>Filter</div>
            <div className='pending-file-filter-menu__subtitle-one'>Uploaded by</div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <MotifCheckbox
                id={`uploader-select-all`}
                label={""}
                checked={
                  Array.isArray(selectedUploader) &&
                  selectedUploader.length > 0 &&
                  selectedUploader.length === Array.from(new Set((items || []).map(file => file.uploadedBy))).length
                }
                onChange={() => { handleToggleSelectAllUploaders() }}
                style={{ marginRight: 8 }}
              />
              <span style={{ fontSize: 14 }}>Select All</span>
            </div>
            <hr className='pending-file-filter-menu__divider-one' />
            {Array.from(new Set((items || []).map(file => file.uploadedBy))).map((uploader) => (
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }} key={uploader}>
                <MotifCheckbox
                  id={`uploader-${uploader}`}
                  label={""}
                  checked={Array.isArray(selectedUploader) ? selectedUploader.includes(uploader) : false}
                  onChange={() => {
                    let updatedUploader;
                    if (Array.isArray(selectedUploader)) {
                      if (selectedUploader.includes(uploader)) {
                        updatedUploader = selectedUploader.filter(u => u !== uploader);
                      } else {
                        updatedUploader = [...selectedUploader, uploader];
                      }
                    } else {
                      updatedUploader = [uploader];
                    }
                    setSelectedUploader(updatedUploader);

                    // Always filter from the original items array, not filteredData
                    if (updatedUploader.length === 0) {
                      setFilteredData(
                        (items || []).filter((item) => {
                          const matchesSearch = item?.fileName && item.fileName.toLowerCase().includes(searchValue.toLowerCase());
                          const shouldShowFile = (activeTab === 'eyOwned' ? item.isEyOwnFolder && !item.isClientDataFolder : item.isEyOwnFolder && item.isClientDataFolder);
                          return matchesSearch && shouldShowFile;
                        })
                      );
                      setSelectedControlIds([]);
                    } else {
                      const filtered = (items || []).filter((file) => {
                        const matchesSearch = file?.fileName && file.fileName.toLowerCase().includes(searchValue.toLowerCase());
                        const shouldShowFile = (activeTab === 'eyOwned' ? file.isEyOwnFolder && !file.isClientDataFolder : file.isEyOwnFolder && file.isClientDataFolder);
                        return matchesSearch && shouldShowFile && updatedUploader.includes(file.uploadedBy);
                      });
                      setFilteredData(filtered);
                    }
                  }}
                  style={{ marginRight: 8 }}
                />
                <span style={{ fontSize: 14 }}>{getUploadedByFormat(uploader)}</span>
              </div>
            ))}
            <hr className='pending-file-filter-menu__divider-two' />
            <div className='pending-file-filter-menu__title-two'>Sort by</div>
            <div className='pending-file-filter-menu__subtitle-two'>Date & Time</div>
            <div
              onClick={() => {
                // Sort filteredData by dateCreated (newest first)
                const sorted = [...filteredData].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));
                setFilteredData(sorted);
                setOnClickNewest(true);
                setOnClickOldest(false);
                setOnClickAtoZ(false);
                setOnClickZtoA(false);
                // If you use filteredData directly, update its source or add a sort state
              }}
              className='pending-file-filter-menu__sort-option-container'
              style={{ background: onClickNewest ? '#E6E6E9' : '' }}
            >
              <img
                src={onClickNewest ? SortUpDark : SortUpLight}
                className={onClickNewest ? '' : 'pending-file-filter-menu__sortup-icon-light'}
                style={{ marginRight: 6, verticalAlign: 'middle' }}
              />
              <span className='pending-file-filter-menu__sort-option'>Newest on top</span>
              {onClickNewest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
            </div>
            <div
              //checked={true} // Replace with your sort state logic
              onClick={() => {
                // Sort filteredData by dateCreated (oldest first)
                const sorted = [...filteredData].sort((a, b) => new Date(a.dateCreated) - new Date(b.dateCreated));
                setFilteredData(sorted);
                // If you use filteredData directly, update its source or add a sort state
                setOnClickOldest(true);
                setOnClickNewest(false);
                setOnClickAtoZ(false);
                setOnClickZtoA(false);
              }}
              className='pending-file-filter-menu__sort-option-container'
              style={{ background: onClickOldest ? '#E6E6E9' : '' }}
            >
              <img
                src={onClickOldest ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              <span className='pending-file-filter-menu__sort-option'>Oldest on top</span>
              {onClickOldest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
            </div>
            <div className='pending-file-filter-menu__subtitle-three'>Alphanumeric</div>
            <div
              onClick={() => {
                // Sort filteredData A to Z
                const sorted = [...filteredData].sort((a, b) => a.fileName.localeCompare(b.fileName));
                setFilteredData(sorted);
                // If you use filteredData directly, update its source or add a sort state
                setOnClickAtoZ(true);
                setOnClickZtoA(false);
                setOnClickOldest(false);
                setOnClickNewest(false);
              }}
              className='pending-file-filter-menu__sort-option-container'
              style={{ background: onClickAtoZ ? '#E6E6E9' : '' }}
            >
              <img
                src={onClickAtoZ ? SortUpDark : SortUpLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              <span className='pending-file-filter-menu__sort-option'>A to Z</span>
              {onClickAtoZ && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
            </div>
            <div
              onClick={() => {
                // Sort filteredData Z to A
                const sorted = [...filteredData].sort((a, b) => b.fileName.localeCompare(a.fileName));
                setFilteredData(sorted);
                // If you use filteredData directly, update its source or add a sort state
                setOnClickZtoA(true);
                setOnClickAtoZ(false);
                setOnClickOldest(false);
                setOnClickNewest(false);
              }}
              className='pending-file-filter-menu__sort-option-container'
              style={{ background: onClickZtoA ? '#E6E6E9' : '' }}
            ><img
                src={onClickZtoA ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              <span className='pending-file-filter-menu__sort-option'>Z to A</span>
              {onClickZtoA && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
            </div>
          </MotifMenu>)}
       
                {allProtectedFiles.length == 0 && <div className="file-list-breadcrumb-message" >
                  <MotifIcon src={IconoirLockSlash} />
                  <MotifLabel> <strong>None of the files require a password </strong></MotifLabel>
                  <MotifLabel>You can "Close" to continue</MotifLabel>
                </div>
                }

              </div>
              <div style={{ overflowY:'scroll',height:'47vh'}}>
                {(() => {
                  const isSearching = (searchValue || "").trim().length > 0;

                  // Search active: show matching files flattened (including files inside folders)
                  if (isSearching) {
                    if (filteredData.length === 0) {
                      return (
                        <div className="no-search-results-message">
                          <span>No Files to View</span>
                        </div>
                      );
                    }
                    return (
                      <>
                        {filteredData.map((file) => (
                          <PendingFileTile
                            key={`${file.fileName}-${file.controlId}`}
                            file={file}
                            onPasswordChange={onPasswordChange}
                            passwords={passwords}
                            handleUnlockFile={handleUnlockFile}
                            isCorrectPassword={isCorrectPassword[file.controlId] || false}
                            showError={showError[file.controlId] || false}
                            rowData={rowData}
                            isSelected={selectedControlIds.includes(file.controlId)}
                            onSelectFile={handleSelectFile}
                            onDelete={handleDeleteFile}
                            showValidatingLoader={showValidatingLoader[file.controlId] || false}
                            searchValue={searchValue}
                            isDeleting={deletingFiles.has(file.controlId)}
                          />
                        ))}
                      </>
                    );
                  }

                  // Default (not searching): original folder + file view
                  // Determine folder order based on sort state
                  let folderEntries = Object.entries(currentFolderContents?.subFolders || {});
                  if (onClickAtoZ) {
                    folderEntries = folderEntries.sort(([a], [b]) => a.localeCompare(b));
                  } else if (onClickZtoA) {
                    folderEntries = folderEntries.sort(([a], [b]) => b.localeCompare(a));
                  }
                  return (
                    <>
                      {folderEntries.map(([name, content]) => {
                        const fileCount = countFilesRecursively(content);
                        const hasProtectedItems = hasProtectedFiles(content.path, isCorrectPassword);
                        const isValidationInProcess = isFileValidationInProcess(content.path, showValidatingLoader);
                        const isZip = name.endsWith(".zip");
                        const isPasswordVisibleForFolder = isPasswordVisible[content.path] ?? false;
                        const allFiles = getAllFilesRecursively(content);

                        // Find the most recent uploadedBy in this folder
                        let uploadedBy = "";
                        let latestDate = null;
                        allFiles.forEach(file => {
                          if (file.dateCreated) {
                            const fileDate = new Date(file.dateCreated);
                            if (!latestDate || fileDate > latestDate) {
                              latestDate = fileDate;
                              uploadedBy = file.uploadedBy;
                            }
                          }
                        });

                        return (
                          <div className="ft-file-item-pending">

                            <div className="ft-file-icon-pending">
                              <MotifCheckbox
                                id={name}
                                value={name}
                                checked={allFiles.every(file => selectedControlIds.includes(file.controlId))}
                                onChange={() => handleFolderCheckboxChange(name, allFiles)}
                              // style={{ marginTop: '10px' }} // Add margin to separate checkbox from icon
                              />
                              <img src={isZip ? require("../../common/images/zip.png") : require("../../common/images/folder.png")} alt={isZip ? "ZIP file icon" : "Folder icon"} />

                            </div>
                            <div className="ft-file-details">
                              <div className={!hasProtectedItems ? "ft-file-name cursor-pointer ft-grid-passwordProtected" : "ft-file-name cursor-pointer ft-folder-protected ft-grid-passwordProtected"} key={name}>
                               <div> <span className={!hasProtectedItems ? "ft-file-name-text" : "ft-file-name-text ft-folder-protected"} onClick={() => navigateToFolder(name)}  title={name}>{name}</span>
                                  <div className="ft-file-type"> <span className='spn-file-type-label'>Type:</span> {isZip ? "ZIP File" : "Folder"}, {fileCount} Files</div>
                            </div>
                                 {hasProtectedItems && (
                                <div className="ft-file-password-wrapper">
                                  <div className="input-container">
                                    <MotifInput
                                      placeholder="Enter password"
                                      className="ft-file-password-input input-container-pendingFiles"
                                      onChange={(e) => onPasswordChange(content.path, e.target.value)}
                                      value={passwords[content.path] ?? ''}
                                      type={isPasswordVisibleForFolder ? 'text' : 'password'}
                                      hideClearButton={true}
                                    />
                                    {passwords[content.path] && (
                                      <button className="ft-password-toggle ft-password-toggle-pending" onClick={() => togglePasswordVisibility(content.path)}>
                                        <MotifIcon src={isPasswordVisibleForFolder ? eyeCloseIcon : eyeIcon} />
                                      </button>
                                    )}
                                  </div>
                                  <div className="tooltip">
                                    {isValidationInProcess || engLevelValidating ? (
                                      <div className="pt-file-unlock-circle">
                                        <SmallCircleLoader />
                                      </div>
                                    ) : (
                                      <>
                                      <MotifTooltip
                                                          allowClick
                                                          allowHover
                                                          closeButtonProps={{}}
                                                          flip
                                                          id="tooltip"
                                                          placement="auto"
                                                          trigger={
                                                              <MotifIcon
                                                                  style={{ marginTop: '6px' }}
                                                                  src={checkPwdIcon}
                                                                  onClick={() => handleFolderUnlock(content.path)}
                                                              />
                                                          }
                                                          onClick={() => handleFolderUnlock(content.path)}
                                                          variant="default"
                                                      >
                                                         Enter a common password to<br/> unlock files in this Folder/Zip.
                                                      </MotifTooltip>
                                        {/* <button className="pt-file-unlock" onClick={() => handleFolderUnlock(content.path)}>
                                          <MotifIcon src={checkPwdIcon} />
                                        </button>
                                        <span className="tooltiptext">Enter a common password to unlock files in this Folder/Zip.</span> */}
                                      </>
                                    )}
                                  </div>
                                </div>
                              )}

                              </div>

                              <div className="pending-file-meta-row">
                                <span className="pending-file-meta-value">
                                  {latestDate
                                    ? getDateTimeFormat(latestDate) +","
                                    : ""}
                                </span>
                                <span className="pending-file-meta-label">
                                  Uploaded by:
                                </span>
                                <span className="pending-file-meta-value">
                                  {getUploadedByFormat(uploadedBy)}
                                </span>
                              </div>

                             
                             
                            </div>
                             <div className="ft-file-actions ft-file-actions-pendingFiles" style={{marginTop: '5px'}}>
                                {hasProtectedItems && (
                                  <>
                                    <button
                                      className="ft-file-remove ft-file-remove-pendingFiles"
                                      disabled={allFiles.some(file => deletingFiles.has(file.controlId))}
                                      onClick={() => handleDeleteSelectedFiles(allFiles)}
                                    >
                                      {allFiles.some(file => deletingFiles.has(file.controlId)) ? (
                                        <SmallCircleLoader color="#ff0000" />
                                      ) : (
                                        <MotifIcon src={deleteIcon} />
                                      )}
                                    </button>
                                    <button className='ft-file-lock-icon'>
                                    {!allFiles.some(file => deletingFiles.has(file.controlId)) && (
                                      <MotifIcon src={lockIcon} className="ft-file-lock-icon" />
                                    )}
                                    </button>
                                  </>
                                )}
                              </div>
                          </div>
                        );
                      })}

                      {/* Render files in current folder */}
                      {Object.entries(currentFolderContents?.files || {}).map(([name, file]) => (
                        <PendingFileTile
                          key={`${file.fileName}-${file.controlId}`}
                          file={file}
                          onPasswordChange={onPasswordChange}
                          passwords={passwords}
                          handleUnlockFile={handleUnlockFile}
                          isCorrectPassword={isCorrectPassword[file.controlId] || false}
                          showError={showError[file.controlId] || false}
                          rowData={rowData}
                          isSelected={selectedControlIds.includes(file.controlId)}
                          onSelectFile={handleSelectFile}
                          onDelete={handleDeleteFile}
                          showValidatingLoader={showValidatingLoader[file.controlId] || engLevelValidating}
                          isDeleting={deletingFiles.has(file.controlId)}
                        />
                      ))}
                    </>
                  );
                })()}
              </div>
              {/* {allProtectedFiles.length !== 0 && <div className="text-container">
                <span className="ft-normal-small">Your password is encrypted and stored temporarily and will be deleted after processing the files.</span>
              </div>} */}
            </div>
            <div className={`uploader-actions pending-action ${filteredData.length === 0 ? 'fixed-bottom-right' : ''}`} >
              <MotifButton variant="primary" onClick={handleClose}>
                Close
              </MotifButton>
            </div>
          </>
        )}

        {/* ... other parts like the text container ... */}
      </div>
      )}
      {/* Render the file list below both tabs */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <IconButton
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <div className="heading">Note</div>
        </DialogTitle>
        <DialogContent>
          <span id="alert-dialog-description">
            The password you have entered is incorrect.
          </span>
        </DialogContent>
        <DialogActions>
          <MotifButton onClick={handleDialogClose} color="primary" autoFocus>
            Close
          </MotifButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='deleteDialogBox'
      >
        <DialogTitle>
          <IconButton
            onClick={handleDeleteDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img src={require("../../common/images/warning-triangle.png")} alt={"Note"} />

        </DialogTitle>
        <DialogContent>
          <span id="alert-dialog-description">
            <strong>
              {selectedControlIds.length > 1
                ? "Are you sure you want to permanently delete the selected " + selectedControlIds.length + " files?"
                : "Are you sure you want to permanently delete this file?"}
            </strong>
            <p>This action cannot be undone.</p>
          </span>
        </DialogContent>
        <DialogActions>

          <MotifButton onClick={handleDeleteDialogClose} color="secondary" variant='secondary' >
            Cancel
          </MotifButton>
          <MotifButton onClick={confirmDeleteFiles} color="primary">
            Yes
          </MotifButton>
        </DialogActions>
      </Dialog>
    </MotifMenu>

    )
  );
};